module.exports = __webpack_public_path__ + "static/media/cartContainer.37629b8d.png";